import { Lang } from '@models/Lang'
import {
  WhatsappBotSettingKey,
  WhatsappBotSettingKeyInputType,
  whatsappBotSettingsByType,
} from '@models/WhatsappBotSetting'
import { useAppSelector } from '@store/hooks'
import { selectWhatsappBotSettingByKey } from '@store/WhatsappBotSettingReducer'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form, Input, Space } from 'antd'
import { useEffect, useMemo } from 'react'
import { langList } from '../../../factories/Utils'
import { Localizable } from '../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const langs: Lang[] = langList
  const { metadata, getMetadata } = useSBRMForm()

  const whatsappBotSettingKey = useMemo(
    () => getMetadata(MetadataKey.WhatsappBotSetting) as WhatsappBotSettingKey,
    [metadata]
  )

  const inputType = useMemo(() => {
    if (!whatsappBotSettingKey) return null

    return whatsappBotSettingsByType[whatsappBotSettingKey] ?? null
  }, [whatsappBotSettingKey])

  const venueId = useMemo(() => getMetadata(MetadataKey.Venue), [metadata])
  const extraProps = getMetadata(MetadataKey.ExtraProps) || {}

  const item = useAppSelector(
    selectWhatsappBotSettingByKey(whatsappBotSettingKey)
  )

  useEffect(() => {
    if (item) {
      form.setFieldsValue({
        ...item,
        venueId: venueId,
        key: whatsappBotSettingKey,
      })
    } else {
      form.setFieldsValue({
        venueId: venueId,
        key: whatsappBotSettingKey,
      })
    }
  }, [item, form, whatsappBotSettingKey])

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden noStyle>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="key" hidden noStyle>
        <Input type="hidden" />
      </Form.Item>
      {inputType &&
        {
          [WhatsappBotSettingKeyInputType.inputText]: (
            <Space orientation="vertical" className="w-full" size={20}>
              {langs.map((lang) => (
                <Localizable.Input
                  noStyle
                  key={lang.code}
                  name="value"
                  max={20}
                  selectedLangCode={lang.code}
                  rules={[requiredRule()]}
                />
              ))}
            </Space>
          ),
          [WhatsappBotSettingKeyInputType.textarea]: (
            <Space orientation="vertical" className="w-full" size={20}>
              <Localizable.TextArea
                name="value"
                label={extraProps?.label}
                rules={[requiredRule()]}
                max={200}
              />
            </Space>
          ),
          [WhatsappBotSettingKeyInputType.venueIdInputText]: (
            <>
              <Form.Item name="venueId" hidden noStyle>
                <Input type="hidden" />
              </Form.Item>
              <Space orientation="vertical" className="w-full" size={20}>
                {langs.map((lang) => (
                  <Localizable.Input
                    noStyle
                    key={lang.code}
                    rules={[requiredRule()]}
                    name="value"
                    max={20}
                    selectedLangCode={lang.code}
                  />
                ))}
              </Space>
            </>
          ),
          [WhatsappBotSettingKeyInputType.venueIdTextarea]: (
            <>
              <Form.Item name="venueId" hidden noStyle>
                <Input type="hidden" />
              </Form.Item>
              <Space orientation="vertical" className="w-full" size={20}>
                <Localizable.TextArea
                  rules={[requiredRule()]}
                  name="value"
                  label={extraProps?.label}
                  max={4096}
                />
              </Space>
            </>
          ),
        }[inputType]}
    </Form>
  )
}

export default Update
